import React, { FC, useContext, useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useStyles } from "./styles";

import { Card, CardMedia, CardContent, Typography, Button } from '@material-ui/core';
import { Container } from '@material-ui/core';
import Alert from '../../components/Alert/AlertComponent';
import ScreenLoader from "../../components/ScreenLoader";
import ButtonsAdd from "../../components/Products/ButtonsAdd";
import ClearIcon from '@material-ui/icons/Clear';
import IconButton from "@material-ui/core/IconButton";
import Grid from '@material-ui/core/Grid';
import SnackBarAlert from "../../components/Alerts/AlertComponent";

import { addToCart, removeFromCart, resetMessage } from '../../flux/actions/shoppingCart-actions';
import { AppContext } from '../OrderFlux/Context';

const Cart: FC = () => {
    // Stepper Context
    const { handleNext } = useContext(AppContext);

    const location = useLocation();
    const params = useParams();

    //URL Data
    const productId = (params as any)?.id;
    const qty = location.search ? Number(location.search.split('=')[1]) : 1;

    //Styles
    const classes = useStyles();

    //Redux
    const dispatch = useDispatch();
    const cart = useSelector((state: any) => state.cart);
    const { cartItems, isProductDeleted, isProductAdded } = cart;

    const [showError, setShowError] = useState(false);

    const removeFromCartHandler = (id: string) => {
        dispatch(removeFromCart(id));
        setTimeout(() => {
            dispatch(resetMessage());
        }, 3000);
    }

    //To clean variables
    useEffect(() => {
        window.scrollTo(0,0);
        dispatch(resetMessage());
    }, [dispatch]);

    //Adds a product by passing an id through the URL
    useEffect(() => {
        if (productId) {
            dispatch(addToCart(productId, qty));
        }
    }, [dispatch, productId, qty]);

    //Redirect to shipping route after click on pay button (only if user is logged in)
    const checkoutHandler = () => {
        handleNext();
    }

    return (
        <Container component="main" maxWidth="md">
            <ScreenLoader isOpen={isProductDeleted}/>
            <h1 className={classes.shoppingCartTitle}>
                Carrito de compras
            </h1>
            {isProductAdded && <SnackBarAlert severity='success' message='Se ha agregado un producto al carrito' open={isProductAdded}/>}
            { cartItems.length === 0
                ?
                    <div style={{ marginBottom: '10rem' }}>
                        <Alert severity="info">
                            Tu carrito está vacío <Link to="/tienda" className='text-underline'>Ir a la Tienda</Link>
                        </Alert>
                    </div>
                :
                    (
                        <Grid container spacing={1} justify="center" alignItems="center">
                            <Grid item xs={12} sm={12} md={9} >
                                {cartItems.map((product: any, i: number) => (
                                        <Card key={i} className={classes.shoppingCartContainer}>
                                            <CardMedia
                                                title= {product.full_name}
                                                className={classes.cardMedia}
                                                image={product.image}
                                            />
                                            <CardContent className={classes.cardContent}>
                                                <Grid container spacing={2} direction='row' justify="center" alignItems="center">
                                                    <Grid item sm={12} md={5} className='productDetails'>
                                                        <Typography variant="h5" component="p">{product.full_name}</Typography>
                                                        <Typography variant="h6" component="p" className='product-price'>${product.cost ? product.cost.toFixed(2) : 0}</Typography>
                                                    </Grid>
                                                    <Grid item sm={12} md={5}>
                                                        <ButtonsAdd 
                                                            qty={product.qty} 
                                                            itemId= {product.id} 
                                                            max={product.amount} 
                                                            showError={setShowError}
                                                        />
                                                    </Grid>
                                                    <Grid item sm={12} md={2} className='delete-icon-container'>
                                                        <IconButton onClick={() => removeFromCartHandler(product.id)}>
                                                            <ClearIcon className='delete-icon'/>
                                                        </IconButton>
                                                    </Grid> 
                                                </Grid>
                                            </CardContent>
                                        </Card>
                                ))}
                            </Grid>
                            <Grid item xs={12} sm={12} md={3} className={classes.orderSummaryContainer}>
                                <Card>
                                    <Typography variant="h5" component="h5" align='center'>
                                        <span className='total-label'>TOTAL</span>
                                        <span className='total-price'>${cartItems.reduce((acc: number, product: any) => acc + (product.cost * product.qty), 0).toFixed(2)}</span>
                                    </Typography>
                                    <Button variant='contained' color='secondary' size='medium' onClick={checkoutHandler}>Pagar</Button>
                                </Card>
                            </Grid>
                        </Grid>
                    )
            }
            { showError &&
                <SnackBarAlert
                    message={"Máxima cantidad posible"}
                    severity="error"
                    open={showError}
                />
            } 
        </Container>
    )
}

export default Cart;
